module.exports = __webpack_public_path__ + "static/media/23-8.033cdc36.mp3";